import { useLang } from "../i18n";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";

const Legal = ({ kind }) => {
  const { t } = useLang();
  const page = t.legalPages[kind];
  const paths = { legal: "mentions-legales", privacy: "confidentialite", cookies: "cookies" };

  return (
    <div data-testid={`legal-page-${kind}`}>
      <Seo title={page.title} path={paths[kind]} />
      <PageHero eyebrow="BULA TELECOMS SA" title={page.title} crumbs={[{ label: page.title }]} />
      <section className="bg-[#F5F5F3]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-24 space-y-10">
          {page.sections.map((s, i) => (
            <Reveal key={s.h} delay={i * 60} className="bg-white border border-[#101214]/10 rounded-2xl p-7">
              <h2 className="text-lg font-bold text-[#101214]">{s.h}</h2>
              <p className="mt-3 text-sm text-[#101214]/70 leading-relaxed whitespace-pre-line">{s.p}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Legal;
